import { Moment } from "moment";
import { Segment, EnhancedSegment } from "./segment";
import { Stop } from "./stop";

export class Route {
    id: number;
    number: string;
    stopIds: number[] = [];
    reverseStopIds: number[] = [];
    railIds: number[] = [];
    reverseRailIds: number[] = [];
    color: string;

    isEnabled: boolean = true;
    isSelected: boolean = false;

    get allStopIds(): number[] {
        let ids = this.stopIds.concat(this.reverseStopIds);
        return Array.from(new Set(ids));
    }
    get allRailIds(): number[] {
        let ids = this.railIds.concat(this.reverseRailIds);
        return Array.from(new Set(ids));
    }

    static get empty(): Route {
        let route = new Route();
        route.id = -1;
        route.number = 'не опознан';
        route.isEnabled = false;

        return route;
    }
}

export class BuiltRoute {
    id: number;
    segments: Segment[];
    departureTime: Date;
    arrivalTime: Date;
    duration: number;
    isSelected: boolean = false;
}

export class EnhancedBuiltRoute {
    private _builtRoute: BuiltRoute;
    private _outerStops: Stop[];

    get id(): number {
        return this._builtRoute.id;
    }

    get departureTime(): Date {
        return this._builtRoute.departureTime;
    }

    get arrivalTime(): Date {
        return this._builtRoute.arrivalTime;
    }

    get duration(): number {
        return this._builtRoute.duration;
    }

    segments: EnhancedSegment[];
    isSelected: boolean = false;

    get outerStops(): Stop[] {
        if (!this._outerStops || !this._outerStops.length) {
            if (this.segments && this.segments.length) {
                let startSegment = this.segments[0];
                let finishSegment = this.segments[this.segments.length - 1];
                this._outerStops = [startSegment.startStop, finishSegment.finishStop];
            }
        }

        return this._outerStops;
    }

    constructor(builtRoute: BuiltRoute) {
        this._builtRoute = builtRoute;
        this.segments = [];
        this._outerStops = [];
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/route.ts